<template>
  <div class="info-card" >
    <a-form-model ref="modalForm" layout="inline" class="form-in-threecolumns" :rules="formRules" :label-col="{span:9}" :wrapper-col="{span:14}" v-show="show">
      <div class="card-content">
        <h3 style="font-weight: bold; color: #333;">投诉添加</h3>
        <h3 style="font-weight: bold; background:#DCDBDC; width:99%; color: #333;">
          <span style="margin-left: 2%">电梯信息</span>
        </h3>
        <a-form-model-item label="救援代码" prop="liftrescue">
          <a-input  v-model="queryForms.liftrescue" placeholder="" style="width:100%;margin-top: -100px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="电梯注册码" prop="liftnum">
          <a-input v-model="queryForms.liftnum" placeholder=""></a-input>
        </a-form-model-item>
          <a-form-model-item label="" prop="callertel">
            <a-button type="primary" @click="liftSelect">选择</a-button>
          </a-form-model-item>
        <a-form-model-item label="安装地址" prop="adress">
          <a-input v-model="queryForms.adress" placeholder=""></a-input>
        </a-form-model-item>
        <h3 style="font-weight: bold; background:#DCDBDC; width:99%; color: #333;margin-top: 1%">
          <span style="margin-left: 2%">单位信息</span>
        </h3>
        <a-form-model-item label="使用单位" prop="userdepname">
          <a-input v-model="queryForms.userdepname" placeholder=""></a-input>
        </a-form-model-item>
        <a-form-model-item label="负责人" prop="userdeppreson">
          <a-input  v-model="queryForms.userdeppreson" placeholder="" style="width:100%;margin-top: -100px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="userdeppersonphone">
          <a-input v-model="queryForms.userdeppersonphone" placeholder=""></a-input>
        </a-form-model-item>
        <a-form-model-item label="维保单位" prop="maintenancedepname">
          <a-input v-model="queryForms.maintenancedepname" placeholder=""></a-input>
        </a-form-model-item>
        <a-form-model-item label="负责人" prop="maintenanceperson1">
          <a-input v-model="queryForms.maintenanceperson1" placeholder=""></a-input>
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="maintenancedephone">
          <a-input v-model="queryForms.maintenancedephone" placeholder=""></a-input>
        </a-form-model-item>
        <a-form-model-item label="救援单位" prop="pristation">
          <a-input v-model="queryForms.pristation" placeholder=""></a-input>
        </a-form-model-item>
        <a-form-model-item label="负责人" prop="pristationperson">
          <a-input v-model="queryForms.pristationperson" placeholder=""></a-input>
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="pristationperphone">
          <a-input v-model="queryForms.pristationperphone" placeholder=""></a-input>
        </a-form-model-item>
        <h3 style="font-weight: bold; background:#DCDBDC; width:99%; color: #333;margin-top: 1%">
          <span style="margin-left: 2%">投诉人信息</span>
        </h3>
        <a-form-model-item label="投诉人" prop="alarmcaller">
          <a-input  v-model="queryForms.alarmcaller" placeholder="请输入" style="width:100%;margin-top: -100px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="callertel">
          <a-input v-model="queryForms.callertel" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item label="处理状态" prop="status">
          <a-select id="status" placeholder="请选择" v-model="queryForms.status">
            <a-select-option value="">请选择</a-select-option>
            <a-select-option :value="0">已受理</a-select-option>
            <a-select-option :value="1">已完成</a-select-option>
          </a-select>
        </a-form-model-item>
        <h3 style="font-weight: bold; background:#DCDBDC; width:99%; color: #333;margin-top: 1%">
          <span style="margin-left: 2%">接线人信息</span>
        </h3>
        <a-form-model-item label="受理人姓名" prop="username">
          <a-input v-model="username" placeholder="" read-only="read-only"></a-input>
        </a-form-model-item>
        <a-form-model-item label="受理时间" prop="calledtime">
          <a-date-picker
              style="width:100%"
              :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
              format="YYYY-MM-DD HH:mm:ss"
              v-decorator="[
                    'pushtime',
                    {
                      rules: [{ required: true, message: '请输入发布时间!' }]
                    }
                  ]"
              :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              placeholder="请选择时间"
              @change="onChange"/>
        </a-form-model-item>
        <h3 style="font-weight: bold; background:#DCDBDC; width:99%; color: #333;margin-top: 1%">
          <span style="margin-left: 2%">投诉信息</span>
        </h3>
        <a-form-model-item prop="message" style="width: 48%;">
          <textarea v-model="queryForms.message" style="width:300%;height:150px;margin-left: 35%" placeholder="投诉信息"></textarea>
        </a-form-model-item>
        <div class="showbutton" style="text-align: center">
          <a-button type="primary"  @click="save()">保存</a-button>
          <a-button @click="exit">关闭</a-button>
        </div>
      </div>
    </a-form-model>
    <liftSelect :visible.sync="liftselectVisible" ref="liftselect" :LiftData="liftData" @upDate="change"></liftSelect>
  </div>
</template>

<script>
import moment from "moment";
import liftSelect from "V/yjcz/emergency/liftSelect";
import {getCache} from "U/index";
import {getLiftinfoById} from "A/jcgn";
import {addAlarmessage} from "A/thjlcx";

export default {
  name: "alarmComplaint",
  components: {
    liftSelect
  },
  data() {
    return {
      moment,
      pages: '',
      show:true,
      username:'',
      liftselectVisible:false,
      liftData:'',
      queryForms:{
        liftrescue:'',
        liftnum :'',
        adress:'',
        userdepname:'',
        userdeppreson :'',
        userdeppersonphone:'',
        maintenancedepname :'',
        maintenanceperson1 :'',
        maintenancedephone :'',
        pristation :'',
        rescuepreson :'',
        rescuephone:'',
        alarmtype:'',
        alarmcaller:'',
        callertel:'',
        calledtime:'',
        message:'',
        status:'',
      },
      formRules: {
        liftrescue: [{required: true, message: '请选择电梯' ,trigger:'blur,change'}],
        calledtime: [{required: true, message: '请选择受理时间',trigger:'blur,change'}],
      },
    }
  },
  created() {
    this.init();
  },
  methods: {
    init(){
      this.initData();
    },
    initData(){
      let logininfo = getCache('logininfo', true);
      if (logininfo) {
        this.username = logininfo.usernames;
      }
    },
    onChange (value, dateString) {
      this.queryForms.calledtime=dateString
    },
    liftSelect(){
      this.liftselectVisible=true;
    },
    save(){
      console.log(this.queryForms.liftrescue)
      console.log(this.queryForms.calledtime)
      if(this.queryForms.liftrescue==null||this.queryForms.liftrescue==""||this.queryForms.calledtime==null||this.queryForms.calledtime==""){
        this.$message.info("请填写完整信息")
      }else{
        let params = {
          liftrescue:this.queryForms.liftrescue,
          alarmtype:2,
          caller:this.queryForms.alarmcaller,
          callertel:this.queryForms.callertel,
          called:this.username,
          calltime:this.queryForms.calledtime,
          message:this.queryForms.message,
          status:this.queryForms.status,
        }
        addAlarmessage(params).then(res=>{
          if(res&&res.returncode=='0'){
            this.$message.success("保存成功")
            this.exit();
          }
        })
      }
    },
    exit() {
      this.show=false
      this.$emit('alarm',this.show=true)
    },
    change(msg){
      let params = {
        liftid:msg
      }
      getLiftinfoById(params).then(res=>{
        if(res && res.returncode=='0'){
          this.queryForms=res.item
          this.queryForms.maintenancedephone=res.item.userdepLists.maintenancephone1
          this.queryForms.maintenanceperson1=res.item.userdepLists.maintenanceperson1
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.card-content {
  padding-bottom: 15px;
  padding-left: 15px;
}
</style>